"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberInput = _interopRequireDefault(require("./NumberInput"));

var PhoneInput = function PhoneInput(_ref) {
  var format = _ref.format,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["format"]);
  return /*#__PURE__*/_react.default.createElement(_NumberInput.default, (0, _extends2.default)({}, otherProps, {
    format: format
  }));
};

PhoneInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Value that controls the  */
  value: _propTypes.default.string,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** Hash based string */
  format: _propTypes.default.string,

  /**
   * Links input helper text or footnote text to the input for assistive technology users.
   * Accepts either the id or multiple space-separated ids of the text you want to link to.
   */
  descriptiveTextId: _propTypes.default.string,

  /** The number of asterisks to render in the label */
  asterisks: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
PhoneInput.defaultProps = {
  errorText: '',
  format: '(###) ###-####',
  value: '',
  descriptiveTextId: null,
  asterisks: null,
  fsMask: true
};
var _default = PhoneInput;
exports.default = _default;